import { useState } from "react";
import { CheckCircle2 } from "lucide-react";
import { Link } from "react-router-dom";
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogDescription } from "@/components/ui/dialog";
import { api, apiError } from "@/lib/api";

const EMPTY = { club: "", name: "", email: "", phone: "", address: "", consent: false, website: "" };

export default function TransferDialog({ open, onOpenChange, onDone }) {
  const [f, setF] = useState(EMPTY);
  const [busy, setBusy] = useState(false);
  const [error, setError] = useState("");
  const [done, setDone] = useState(false);
  const set = (k) => (e) => setF({ ...f, [k]: e.target.type === "checkbox" ? e.target.checked : e.target.value });

  const submit = async (e) => {
    e.preventDefault();
    setBusy(true);
    setError("");
    try { await api.post("/transfer-requests", f); setDone(true); onDone?.(); }
    catch (err) { setError(apiError(err)); }
    finally { setBusy(false); }
  };

  const close = (o) => { onOpenChange(o); if (!o && done) { setDone(false); setF(EMPTY); } };

  return (
    <Dialog open={open} onOpenChange={close}>
      <DialogContent className="max-w-[500px] max-h-[92vh] overflow-y-auto rounded-[14px]" data-testid="transfer-dialog">
        {done ? (
          <div className="py-4" data-testid="transfer-success">
            <CheckCircle2 size={32} className="text-[#1E6B45]" />
            <p className="text-[15px] leading-relaxed mt-4">Merci ! Vous recevez votre facture avec nos coordonnées bancaires sous 24 h. Votre place est confirmée dès réception du virement.</p>
            <button className="btn-primary mt-6" onClick={() => close(false)} data-testid="transfer-success-close">Fermer</button>
          </div>
        ) : (
          <>
            <DialogHeader>
              <DialogTitle className="font-display text-xl">Payer par virement sur facture</DialogTitle>
              <DialogDescription>Nous vous envoyons une facture avec nos coordonnées bancaires.</DialogDescription>
            </DialogHeader>
            <form onSubmit={submit} className="space-y-4">
              <label className="block"><span className="field-label">Nom du club</span><input className="field" required minLength={2} value={f.club} onChange={set("club")} data-testid="transfer-club-input" /></label>
              <label className="block"><span className="field-label">Nom et prénom</span><input className="field" required minLength={2} autoComplete="name" value={f.name} onChange={set("name")} data-testid="transfer-name-input" /></label>
              <label className="block"><span className="field-label">Email</span><input className="field" type="email" required autoComplete="email" value={f.email} onChange={set("email")} data-testid="transfer-email-input" /></label>
              <label className="block"><span className="field-label">Téléphone</span><input className="field" type="tel" required inputMode="tel" autoComplete="tel" value={f.phone} onChange={set("phone")} data-testid="transfer-phone-input" /></label>
              <label className="block"><span className="field-label">Adresse postale du club (pour la facture)</span><textarea className="field h-auto min-h-[80px] py-2" required minLength={5} autoComplete="street-address" value={f.address} onChange={set("address")} data-testid="transfer-address-input" /></label>
              <input type="text" tabIndex={-1} autoComplete="off" className="hidden" value={f.website} onChange={set("website")} aria-hidden="true" />
              <label className="flex gap-3 items-start text-[13px] text-[#5B665F] leading-relaxed cursor-pointer">
                <input type="checkbox" required className="w-4 h-4 mt-0.5 accent-[#1E6B45] shrink-0" checked={f.consent} onChange={set("consent")} data-testid="transfer-consent-checkbox" />
                <span>J'accepte d'être recontacté au sujet de ma réservation. <Link to="/confidentialite" className="link">Politique de confidentialité</Link></span>
              </label>
              {error && <p className="text-sm text-[#8A4B00] bg-[#FDEBD3] rounded-lg px-3 py-2" data-testid="transfer-error">{error}</p>}
              <button type="submit" className="btn-primary w-full h-12" disabled={busy} data-testid="transfer-submit-button">{busy ? "Envoi…" : "Recevoir ma facture"}</button>
            </form>
          </>
        )}
      </DialogContent>
    </Dialog>
  );
}
